import axios from "axios";
import {getField, updateField} from "vuex-map-fields";
import i18n from '@/i18n';
import Vue from "vue";

export default {
  namespaced: true,
  state: {
      fetched: false,
      savingInProgress: false,
      pricelistFileParams:{
          filename: null,
          extension: null
      },
      encodings: [
          "UTF-8",
          "UTF-7",
          "Windows 1253",
          "Windows 1251",
          "Windows 1250",
          "KOI8-R",
          "KOI8-RU",
          "ISO8859-5",
          "DOS 866",
          "GB2312"
      ],
      delimiters: [
          {'name':";", 'value':";"},
          {'name':",", 'value':","},
          {'name':"|", 'value':"|"},
          {'name':"\\t", 'value':"\t"},
      ],
      pricelistSaleType:[
          {
              'name':'retail', //розница
              'value':0
          },
          {
              'name': 'wholesale', //опт
              'value':1
          }
      ],
      pricelistSaleState:[
          {
              'name':'unused_new', //новые
              'value':0
          },
          {
              'name': 'used', //б.у
              'value':1
          }
      ],
      pricelistAvailableColumns:[
          {'name': 'part_number', 'required': true}, //*
          {'name': 'brand', 'required': true}, //*
          {'name': 'price', 'required': true}, //*))
          {'name': 'count', 'required': false},
          {'name': 'min_count', 'required': false},
          {'name': 'delivery', 'required': false},
          {'name': 'part_name', 'required': false},
          {'name': 'not_chosen', 'required': false, 'not_chosen': true}, //
      ],
      pricelist: {
          id:null,
          file:null,
          supplier_id: null,
          delimiter: '',
          encoding: null,
          language: null,
          table_config: {
              start_row: 1,
              columns:[
                  {'name': 'part_number'}, //*
                  {'name': 'brand'}, //*
                  {'name': 'price'}, //*))
              ]
          },
          price_sale: null,
          price_state: null,
          price_margin: null,
          delivery: null,
      },
      pricelists:[]
  },
  getters:{
    getField, //vuex-map-fields
  },
  mutations: {
    updateField, //vuex-map-fields
    removePricelistsFromState(state, id){
      let pricelists = [];
      Object.entries(state.pricelists).forEach(role =>{
          if( Number(role[1].id)!=Number(id)){
              pricelists.push(role[1]);
          }
      });
      Vue.set(state, 'pricelists', pricelists);
      //state.fetched = true;
    },
  },
  actions: {
    pricelistsUpdate({ commit, state, dispatch }, payload){
      updateField(state, {path:'savingInProgress', value:true});
      let data =  Object.assign({}, state.pricelist);
      for ( let key in state.pricelist ) {
          if(key=='table_config'){
              data['table_config'] = JSON.stringify(state.pricelist[key]);
          }
      }
      return axios.put(this._vm.$apiURL + '/pricelists/'+payload.id, data)
        .then((response) => {
          this._vm.$inform(this._vm.i18n.t('common.operation_success'));
        })
        .catch((error) => {
            dispatch('common/showError', {'error': error}, {root:true});
        }).finally(()=>{
            updateField(state, {path:'savingInProgress', value:false});
        })
    },
    replaceFile({ commit, state, dispatch }, payload){
        let formData = new FormData();
        formData.append('file', payload.file);
        return axios.post(this._vm.$apiURL + '/pricelists-replace-file/'+payload.id, formData, {
            headers: {
                'Content-Type': 'multipart/form-data'
            }}
        )
            .then((response) => {
                this._vm.$inform(this._vm.i18n.t('common.operation_success'));
                dispatch('pricelistsGet');
            })
            .catch((error) => {
                dispatch('common/showError', {'error': error}, {root:true});
            })
            .finally(()=>{
                updateField(state, {path:'savingInProgress', value:false});
            })
    },
    pricelistsStore({ commit, state, dispatch }){
        updateField(state, {path:'savingInProgress', value:true});
        let formData = new FormData();
        for ( let key in state.pricelist ) {
            if(key!='table_config'){
                formData.append(key, state.pricelist[key]);
            } else{
                formData.append(key, JSON.stringify(state.pricelist[key]));
            }
        }
        return axios.post(this._vm.$apiURL + '/pricelists', formData, {
        headers: {
            'Content-Type': 'multipart/form-data'
        }}
        )
        .then((response) => {
          this._vm.$inform(this._vm.i18n.t('common.success_add'));
          return response.data.id;
        })
        .catch((error) => {
            dispatch('common/showError', {'error': error}, {root:true});
        })
        .finally(()=>{
            updateField(state, {path:'savingInProgress', value:false});
        })
    },
    pricelistShow({ commit, state, dispatch }, payload){
      return axios.get(this._vm.$apiURL + '/pricelists/'+payload.id)
        .then((response) => {
            let pricelist = response.data;
            if(response.data.config){
                pricelist.table_config = {};
                pricelist.table_config.start_row = response.data.config.start_row;
                pricelist.table_config.columns = [];
                let table_config_keys = Object.keys(response.data.config);
                for(let i in table_config_keys){
                    for (let j in state.pricelistAvailableColumns){
                        if(state.pricelistAvailableColumns[j].name == table_config_keys[i]){
                            if(response.data.config[table_config_keys[i]]>=0){
                                pricelist.table_config.columns[response.data.config[table_config_keys[i]]] = {'name':table_config_keys[i]}
                            }
                        }
                    }
                }
            }
          updateField(state, {path:'pricelist', value: pricelist});
        })
        .catch((error) => {
            dispatch('common/showError', {'error': error}, {root:true});
        })
    },
    pricelistsGet({ commit, state, dispatch }){
        updateField(state, {path:'fetched', value:true});
        axios.get(this._vm.$apiURL + '/pricelists')
        .then((response) => {
          updateField(state, {path:'pricelists', value:response.data});
        })
        .catch((error) => {
          dispatch('common/showError', {'error': error}, {root:true});
        })
    },
    pricelistRemove({ commit, state, dispatch }, payload){
        this._vm.$confirm( {
            title : this._vm.i18n.t('common.confirm'),
            text : this._vm.i18n.t('common.confirm_remove'),
            cancelText : this._vm.i18n.t('common.no'),
            acceptText : this._vm.i18n.t('common.yes')
        } ).then( y =>{
            return axios.delete(this._vm.$apiURL+'/pricelists/'+payload.id,
                {
                    id:payload.id
                })
                .then(response => {
                    if(response.data.status==='success'){
                        commit('removePricelistsFromState', payload.id);
                        this._vm.$inform( this._vm.i18n.t('common.success_remove') )
                    }
                })
                .catch(error => {
                    dispatch('common/showError', {'error': error}, {root:true});
                });
        }).catch( n => {} );
    },
    async pricelistChangeStatus({ commit, state, dispatch }, payload){
        return await axios.post(this._vm.$apiURL+'/pricelists/'+payload.id+'/change-status')
            .then(response => {
                return response.data.pricelist_status;
            })
            .catch(error => {
                dispatch('common/showError', {'error': error}, {root:true});
            });
    },

  }
}
